import { api } from '@/services'

export const fetchHostInvoices = (id) => {
  return api.get(`/admin/invoice/hostInvoicesReport/${id}`)
}